var script_loaded = false;

function loadJSscripts() {
  if (!script_loaded) {
    script_loaded = true;

    // Lazy load iframes
    document.querySelectorAll("iframe.lazy").forEach(iframe => {
      let dataSrc = iframe.dataset.src;
      if (dataSrc != null) {
        iframe.src = dataSrc;
      }
    });

    // Lazy load scripts
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      let script = scripts[i];
      if (script.getAttribute("data-src") !== null) {
        script.setAttribute("src", script.getAttribute("data-src"));
        delete script.dataset.src;
      }
      if (script.getAttribute("type") === "text/lazyload") {
        var newScript = document.createElement("script");
        for (var a = 0; a < script.attributes.length; a++) {
          var attr = script.attributes[a];
          newScript.setAttribute(attr.name, attr.value);
        }
        newScript.type = "text/javascript";
        newScript.innerHTML = script.innerHTML;
        script.parentNode.replaceChild(newScript, script);
      }
    }

    // Lazy load links
    var links = document.getElementsByTagName("link");
    for (i = 0; i < links.length; i++) {
      let link = links[i];
      if (link.getAttribute("data-href") !== null) {
        link.setAttribute("href", link.getAttribute("data-href"));
        delete link.dataset.href;
      }
    }

    // Dispatch event to notify that lazy loading is done
    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  }
}

// Events that will trigger the lazy loading
var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(event => {
  window.addEventListener(event, loadJSscripts, { once: true });
});

// Load scripts on page load as a fallback
if (window.addEventListener) {
  window.addEventListener("load", loadJSscripts, { once: true });
} else if (window.attachEvent) {
  window.attachEvent("onload", loadJSscripts);
} else {
  window.onload = loadJSscripts;
}
